import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useIntl } from 'react-intl';

import useFetchWrapper, { HttpResponse } from "../../Helpers/useFetchWrapper";
import { useIntlWrapperContext } from '../../Helpers/IntlWrapperProvider';

import { UserApplicationModel, UserApplicationResponse } from "./BackofficeApplicationProfile.model";
import moment from "moment";

const useUserApplication = (props: any) => {
	const [ application, setApplication ] = useState<UserApplicationModel>();
	const [ loading, setLoading ] = useState(true);

  const { get, put } = useFetchWrapper();
  const { applicationId } = props;

  const history = useHistory();
  const intl = useIntl();
  const { getI18nCountryName } = useIntlWrapperContext();
  
  useEffect(() => {
    getUserApplication(applicationId);
	},[])
	
  const getUserApplication = async(applicationId: string) => {
    const response: HttpResponse<UserApplicationResponse> = await get(`/application/${applicationId}`);

    if (response.parsedBody) {
      const {
        email,
        firstName,
        lastName,
        payload,
        previousLnlm,
        role,
        status,
        createdAt
      } = response.parsedBody;

      const {
        currentPosition,
        institution,
        languages,
        location,
        mentoringScopes,
        motivation,
        researchAreas,
        startDate,
      } = payload.MentorApplication || payload.MenteeApplication || {};

      const application: UserApplicationModel = {
        createdAt,
        currentPosition: intl.formatMessage({ id: `currentPosition.${currentPosition}` }),
        email,
        institution,
        languages,
        location: location ? getI18nCountryName(location) : '',
        mentoringScopes: mentoringScopes?.map(item => intl.formatMessage({ id: `mentoringScopes.${item}` })),
        motivation,
        name: `${firstName} ${lastName} `,
        previousLnlm: `${previousLnlm.name} ${moment(previousLnlm.date).format("DD MMM YYYY")}`,
        researchAreas,
        role,
        startDate,
        status,
      };
      setApplication(application);
		}
		
		setLoading(false);
  }

  const onApproveUser = async () => {
    const response = await put(`/application/${applicationId}/accept`, {});
    if (response.ok) {
      history.push("/users");
    }

  }
  const onRejectUser = async () => {
    const response = await put(`/application/${applicationId}/reject`, {});
    if (response.ok) {
      history.push("/users");
    }
  }

  return {
    onApproveUser,
    onRejectUser,
    state: { application, loading },
  }
}

export default useUserApplication;